import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import _ from 'lodash';
import {Table, Card, Grid, Input, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {MAX_LEN_SEARCH} from '../../constants';
import OrderGrid from './orderGrid';
import Response from './response';
import ClearButton from './clearButton';
import './emergingOrders.scss';

class EmergingOrder extends Component {
  constructor(props) {
    super(props);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
  }

  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.DealerEmergingOrders, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.restoreDealerEmergingOrdersPage();
    this.props.getAllAgencies();
  }

  componentWillUnmount() {
    const {quantity, userAgency, mainPart, orderWasCreated} = this.props;

    if (!orderWasCreated && mainPart) {
      const message = 'La redirección continuará después de realizar la siguiente acción: \n\n' +
      'Presione "Aceptar" para registrar una 𝗩𝗲𝗻𝘁𝗮 𝗣𝗲𝗿𝗱𝗶𝗱𝗮, caso contrario presione "Cancelar".';
      const isLostSale = confirm(message); // eslint-disable-line
      if (isLostSale) {
        this.props.saveDealerLostSale({
          'partCode': mainPart.code,
          'dealer': userAgency.dealerId,
          'agency': userAgency.code,
          'quantity': quantity,
        });
      }
    }
    this.props.clearReplacementSectionPartQuotes();
  }

  handleValueChange(event, {name, value}) {
    this.props.updateDealerEmergingOrderValue(name, value.trim().toUpperCase());
  }

  handleQuantityChange(event, {name, value}) {
    this.props.updateDealerEmergingOrderValue(name, parseInt(value.trim(), 10));
  }

  handleSearchClick() {
    const {partCode, quantity} = this.props;

    if (partCode && quantity > 0) {
      this.props.searchDealerEmergingOrder(partCode, quantity);
    }
  }

  render() {
    const {partCode, quantity, userAgency, loading, wasSearched, parts} = this.props;

    if (_.isEmpty(userAgency)) {
      return (
        <Card raised fluid>
          <h2>
            Estimado usuario, su agencia no está habilitada en el sistema,
            por favor comuníquese con Toyota del Ecuador S. A.
          </h2>
        </Card>
      );
    }

    return (
      <div className='dealer-emerging-orders'>
        <Card raised fluid className='head-section'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='8' textAlign='left'>
                <div className="dealer-emerging-orders-header">
                  <h2>Consulta de Stock - Concesionarios</h2>
                  <div>
                    <Link to={paths.PartQuotation}>Ver Cotizador de partes</Link>
                  </div>
                </div>
                <div className='dealer-info'>
                  {userAgency.dealerName} | {userAgency.description}
                </div>
              </Grid.Column>
              <Grid.Column width='8' textAlign='right'>
                <Input
                  name='partCode'
                  maxLength='20'
                  placeholder='Código'
                  disabled={wasSearched}
                  value={partCode}
                  onChange={this.handleValueChange}
                />
                <Input
                  className='quantity'
                  name='quantity'
                  type='number'
                  min='1'
                  max='99999'
                  placeholder='Cantidad'
                  disabled={wasSearched}
                  value={quantity}
                  onChange={this.handleQuantityChange}
                />
                <ClearButton />
                <Button
                  primary
                  disabled={loading || !quantity || !partCode || partCode.length <= MAX_LEN_SEARCH}
                  loading={loading}
                  content='BUSCAR'
                  onClick={this.handleSearchClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>

        <Response />

        <Table striped definition>
          <Table.Header className="emerging-tablel-sticky">
            <Table.Row textAlign='center'>
              <Table.HeaderCell className='clear-corner' />
              <Table.HeaderCell>Código</Table.HeaderCell>
              <Table.HeaderCell>Sustituto</Table.HeaderCell>
              <Table.HeaderCell>Despiece</Table.HeaderCell>
              <Table.HeaderCell>Descontinuado</Table.HeaderCell>
              <Table.HeaderCell>Descripción</Table.HeaderCell>
              <Table.HeaderCell>Stock CPD</Table.HeaderCell>
              <Table.HeaderCell>Precio Sugerido</Table.HeaderCell>
              <Table.HeaderCell>Tipo</Table.HeaderCell>
              <Table.HeaderCell>Orden de reparación</Table.HeaderCell>
              <Table.HeaderCell>Pedido</Table.HeaderCell>
              <Table.HeaderCell>Acciones</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {parts.map((part, idx) => (
              <OrderGrid key={idx} part={part} loading={loading} partLength={parts.length} />
            ))}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {agencies} = state.dealer;
  const {dealerId, dealerAgency} = state.session;
  const userAgency = agencies.find((agency) => agency.dealerId === dealerId && agency.code === dealerAgency);

  return {
    'permissions': state.session.permissions,
    'userAgency': userAgency || {},
    'orders': state.dealerEmergingOrders.list,
    'loading': state.dealerEmergingOrders.loading,
    'orderWasCreated': !!state.dealerEmergingOrders.createdOrder,
    'partCode': state.dealerEmergingOrders.partCode,
    'mainPart': state.dealerEmergingOrders.original,
    'quantity': state.dealerEmergingOrders.quantity,
    'wasSearched': state.dealerEmergingOrders.wasSearched,
    'parts': state.dealerEmergingOrders.parts,
  };
};

const {
  getAllAgencies,
  saveDealerLostSale,
  searchDealerEmergingOrder,
  selectDealerEmergingOrderCode,
  updateDealerEmergingOrderValue,
  restoreDealerEmergingOrdersPage,
  clearReplacementSectionPartQuotes,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  getAllAgencies,
  saveDealerLostSale,
  searchDealerEmergingOrder,
  selectDealerEmergingOrderCode,
  updateDealerEmergingOrderValue,
  restoreDealerEmergingOrdersPage,
  clearReplacementSectionPartQuotes,
  navigateTo,
})(EmergingOrder);
